import { api } from "./http";

export const notificationApi = {
  getMine: (pageNumber = 1, pageSize = 10) =>
    api.get(`/api/Notification?pageNumber=${pageNumber}&pageSize=${pageSize}`),
  getById: (id) => api.get(`/api/Notification/${id}`),
  markRead: (id) => api.put(`/api/Notification/${id}/read`, {}),
  markAllRead: () => api.put("/api/Notification/read-all", {}),
};
